<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.question}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="submit()" color="primary">Oui</button>
  <button mat-button (click)="cancel()">Non</button>
</mat-dialog-actions>
